import loaderClient from "api/reduxLoaderApi";
import { toast } from "react-toastify";
import {
  setAirlinesName,
  setBugReportedList,
  setAirlineBugTotalItems,
  setBugReportSummary,
  setUsersList,
} from "./bugReportedSlice";

const normalizeBugReportsResponse = (res) => {
  const list = Array.isArray(res.message)
    ? res.message
    : Array.isArray(res.message?.bugs)
    ? res.message.bugs
    : Array.isArray(res.message?.data)
    ? res.message.data
    : [];

  const totalItems =
    res.result_number ||
    res.message?.summary?.total ||
    res.message?.result_number ||
    res.message?.total ||
    list.length;

  const summary = {
    total: res.message?.summary?.total ?? totalItems,
    in_progress: res.message?.summary?.in_progress ?? 0,
    resolved: res.message?.summary?.resolved ?? 0,
  };

  return { list, totalItems, summary };
};

export const getBugReported = (params = "limit=all") => async (dispatch) => {
  const client = loaderClient("get")(`/v2/bug-reports?${params}`);
  const res = await client({})({});

  if (res.error) return toast.error(res.message);
  const { list, totalItems, summary } = normalizeBugReportsResponse(res);
  dispatch(setAirlineBugTotalItems(totalItems));
  dispatch(setBugReportSummary(summary));
  return dispatch(setBugReportedList(list));
};

export const updateBugReportStatus = (
  bugId,
  status,
  callback = false
) => async () => {
  const client = loaderClient("patch")(`/v2/bug-reports/${bugId}`);
  const res = await client({ status })({});

  if (res.error) return toast.error(res.message);
  return callback && callback();
};

export const updateBugReportsStatus = (
  bugIds,
  status,
  params = "limit=all",
  callback = false
) => async (dispatch) => {
  for (const bugId of bugIds) {
    const client = loaderClient("patch")(`/v2/bug-reports/${bugId}`);
    const res = await client({ status })({});
    if (res.error) return toast.error(res.message);
  }

  toast.success("Bug report updated");
  dispatch(getBugReported(params));
  return callback && callback();
};

export const resolveBugReported = (
  bugId,
  resolved_note,
  callback = false
) => async (dispatch) => {
  const client = loaderClient("patch")(`/v2/bug-reports/${bugId}/resolve`);
  const res = await client({ resolved_note })({});

  if (res.error) return toast.error(res.message);
  return callback && callback();
};

export const resolveBugReports = (
  bugIds,
  resolved_note,
  params = "limit=all",
  callback = false
) => async (dispatch) => {
  for (const bugId of bugIds) {
    const client = loaderClient("patch")(`/v2/bug-reports/${bugId}/resolve`);
    const res = await client({ resolved_note })({});
    if (res.error) return toast.error(res.message);
  }

  toast.success("Bug report resolved");
  dispatch(getBugReported(params));
  return callback && callback();
};

export const getFilteredBugs = (params) => async (dispatch) => {
  const client = loaderClient("get")(`/v2/bug-reports?${params}`);
  const res = await client({})({});
  if (res.error) return toast.error(res.message);
  const { list, totalItems, summary } = normalizeBugReportsResponse(res);
  dispatch(setAirlineBugTotalItems(totalItems));
  dispatch(setBugReportSummary(summary));
  return dispatch(setBugReportedList(list));
};

export const getUsers = () => async (dispatch) => {
  const client = loaderClient("get")(`/users?limit=all`);
  const res = await client({})({});
  if (res.error) return toast.error(res.message);
  return dispatch(setUsersList(res.message));
};

export const getAirlines = () => async (dispatch) => {
  const client = loaderClient("get")(`/airlines`);
  const res = await client({})({});

  if (res.error) return toast.error(res.message);
  return dispatch(setAirlinesName(res.message));
};
